import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "application-shell"
    }}>{`Application shell`}</h1>
    <p>{`PWA Studio uses an application shell architecture to shorten the time it takes to load a branded experience in the UI instead of a blank page.`}</p>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`The application shell pattern involves heavily caching the minimal amount of HTML, CSS and JS to load the basic UI of the page before fetching the rest through an API.`}</p>
    <p>{`Application shell rendering is instantaneous on repeat visits because the majority of the page is in the cache.
It also prevents unnecessary data usage because it removes the need to download static content more than once.`}</p>
    <p>{`The following is a simple example of an application shell:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <meta http-equiv="X-UA-Compatible" content="ie=edge" />
    <link rel="stylesheet" type="text/css" href="assets/css/shell.css" />
    <title>Document</title>
  </head>

  <body>
    <header>
      <h1>App Shell</h1>
    </header>

    <div class="nav"></div>

    <div class="content"></div>

    <div class="spinner"></div>

    <script>
      if (process.env.SERVICE_WORKER && "serviceWorker" in navigator) {
        window.addEventListener("load", () => {
          navigator.serviceWorker
            .register(process.env.SERVICE_WORKER)
            .then((registration) => {
              console.log("Service worker registered: ", registration);
            })
            .catch((error) => {
              console.log("Service worker registration failed: ", error);
            });
        });
      }
    </script>
  </body>
</html>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      